import types from './types';
import * as api from './api';
import { createTestListActions } from '../../../common/test-list/actions';

export default createTestListActions(types, api);
